// src/pages/ShopifySettings.tsx
import React, { useEffect, useState } from "react";
import { apiGet } from "../api/client";
import ShopifyConnectCard from "../components/ShopifyConnectCard";
import UpgradeModal from "../components/UpgradeModal";
import SectionShell, {
  type SectionTab,
} from "../components/layout/SectionShell";

type AuthMe = {
  is_user_pro?: boolean;
  account_tier?: string | null;
  is_pro?: boolean;
  shopify_connector_active?: boolean;
  can_use_shopify?: boolean;
};

const SHOPIFY_TABS: SectionTab[] = [
  { label: "Overview", to: "/commerce/shopify", end: true },
  { label: "Product Mapping", to: "/commerce/shopify/product-mapping" },
  { label: "Sync Issues", to: "/commerce/shopify/sync-issues" },
  { label: "Activity", to: "/commerce/shopify/diagnostics" },
];

export default function ShopifySettings() {
  const [me, setMe] = useState<AuthMe | null>(null);
  const [planLoading, setPlanLoading] = useState(true);
  const [showUpgrade, setShowUpgrade] = useState(false);

  useEffect(() => {
    let active = true;

    apiGet<AuthMe>("/auth/me")
      .then((res) => {
        if (active) setMe(res);
      })
      .catch(() => {
        if (active) setMe(null);
      })
      .finally(() => {
        if (active) setPlanLoading(false);
      });

    return () => {
      active = false;
    };
  }, []);

  const tier = (me?.account_tier || "").toLowerCase();
  const isPro =
    !!me?.is_user_pro ||
    tier === "pro" ||
    tier === "paid" ||
    tier === "enterprise";

  return (
    <SectionShell
      title="Shopify"
      tabs={SHOPIFY_TABS}
      tabsAriaLabel="Shopify sections"
      closePath="/commerce"
    >
      <main className="mx-auto w-full max-w-3xl">
        <ShopifyConnectCard
          isPro={isPro}
          planLoading={planLoading}
          onUpgradeClick={() => setShowUpgrade(true)}
        />
      </main>

      <UpgradeModal open={showUpgrade} onClose={() => setShowUpgrade(false)} />
    </SectionShell>
  );
}